import React from 'react'

function Footer() {
  return (
    <div id="contactus">
      <footer className="bg-plight border-top"    style={{ position: "relative" }}>
        <img src='/assets/img/vector/leftvector.png' className='right-vector' />
        <img src='/assets/img/vector/Element.png' className='right-vector2' />
        <div className="container py-5" data-aos={window.location?.pathname == "/privacy-policy" ? "": "fade-left"} style={{ position: "relative", zIndex: "5" }}>
          <div className="row text-start text-md-left">

            {/* <!-- Developed Team --> */}
            <div className="col-md-4 mb-4">
              <div className='pb-2'>
                <img alt="logo" style={{ width: "110px" }} className="img-fluid" src="/assets/img/logo.png" />
              </div>
              {/* <h6 className="fw-bold">Developed Team</h6> */}
              <p className="text-muted small">
                Prepare your HR department for the future with our adaptable HRMS, designed to meet the needs of a dynamic workplace and foster a culture of continuous improvement.
              </p>
              <div className='d-flex gap-3'>
                <a href='https://www.facebook.com/profile.php?id=61575695125325' className='footer-icons'>
                  <i className='fa-brands fa-facebook' ></i>
                </a>
                <a href='https://www.instagram.com/hrms_tool/' className='footer-icons' >
                  <i className='fa-brands fa-instagram' ></i>
                </a>
                <a href='https://x.com/home' className='footer-icons' >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.431732 0.333496H4.94539L8.96359 6.0805L13.7887 0.333496H15.231L9.51462 6.86919L15.667 15.6665H11.1533L6.95689 9.66555L1.77529 15.6665H0.333984L6.40681 8.87877L0.431732 0.333496Z" fill="#111827" />
                  </svg>
                </a>
                <a href='https://www.linkedin.com/company/106752764/admin/dashboard/' className='footer-icons' >
                  <i className='fa-brands fa-linkedin' ></i>
                </a>
                
              </div>
            </div>

            {/* <!-- Quick Links --> */}
            <div className="col-md-2 mb-3" >
              <h6 className="fw-bold">Useful Pages</h6>
              <ul className="list-unstyled small text-muted">
                <li className=" my-2"><a href="#products" className="text-decoration-none text-muted" >Products</a></li>
                <li className=" my-2"><a href="#features" className="text-decoration-none text-muted" >Features</a></li>
                <li className=" my-2"><a href="#pricing" className="text-decoration-none text-muted" >Pricing</a></li>
                {/* <li className=" my-2"><a href="#news" className="text-decoration-none text-muted" >News</a></li>  */}
                <li className=" my-2"><a href="/privacy-policy" className="text-decoration-none text-muted" > Privacy Policy</a></li>
              </ul>
            </div>
            <div className="col-md-3 mb-3">
              <h6 className="fw-bold">Company</h6>
              <ul className="list-unstyled small text-muted">
                <li className=" my-2"><a href="https://www.cvinfotech.com/about-us/" className="text-decoration-none text-muted">About</a></li>
                <li className=" my-2"><a href="https://www.cvinfotech.com/blog/" className="text-decoration-none text-muted">Blogs</a></li>
                <li className=" my-2"><a href="https://www.cvinfotech.com/customer-testimonials/" className="text-decoration-none text-muted">Testimonials</a></li>

              </ul>
            </div>


            <div className="col-md-3 mb-4">
              <h6 className="fw-bold">Contact Us</h6>
              <p className="mb-2 small text-muted d-flex gap-1 align-items-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-mail"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" /><path d="M3 7l9 6l9 -6" /></svg>
                <a href="mailto:hrms@cvinfotech.com" className="text-decoration-none text-muted">hrms@cvinfotech.com</a>
              </p>
              <p className="small text-muted d-flex gap-1 align-items-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-phone"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                <a href="tel:+918448848632" className="text-decoration-none text-muted">+91-8448848632</a>
              </p>
            </div>

          </div>
        </div>

        <div className=" bottom-bar  py-4 px-4  border-top ">
          <div className='container d-flex justify-content-between'>
            <p className='m-0 ' style={{ fontSize: "12px" }}>
              Copyright @ 2025 HRMS Tool.
            </p>
            {/* <a href='/privacy-policy'>Privacy Policy</a> */}
            <p className='m-0 ' style={{ fontSize: "12px" }}>
              All Rights Reserved. Powered By CV Infotech
            </p>
          </div>
        </div>
      </footer>

    </div>
  )
}

export default Footer
